/**
 * Checks whether the application-fees API response contains any
 * configured fee with a positive amount.
 *
 * The response may or may not be wrapped in a `to` property depending
 * on which endpoint/client is used. Normalise to handle both shapes.
 */
export function hasConfiguredApplicationFees(applicationFees) {
  const fees = applicationFees?.to ?? applicationFees;
  return (
    (fees?.resident?.admin?.amount ?? 0) > 0 ||
    (fees?.resident?.application?.amount ?? 0) > 0 ||
    (fees?.resident?.depositAlternative?.amount ?? 0) > 0 ||
    (fees?.security?.deposit?.amount ?? 0) > 0
  );
}
